module.exports = require('./src/index.tsx');
